export const OPEN_SHARE_OPTIONS_EVENT = 'openshareoptions';
